import React, { useEffect, useState } from "react";
import logo from "../../assets/192.png";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { Alert, Button, Col, Container, Row, Spinner } from "react-bootstrap";
import { PayloadProps } from "../../core/schema";
import apiEndpoint from "../../core/apiend_point";
import { triggerApi } from "../../services";
import OtpInput from "./OtpInput";
import Modal from "react-bootstrap/Modal";
import { getLocalStorage, setLocalStorage } from "../../core/localStorageService";
import { useNavigate } from "react-router-dom";

/**
 * Renders Component.
 * @return {SignIn} renders Component.
 */
export default function SignIn() {
  const [showVerify, setShowVerify] = useState(false);
  const [otp, setOtp] = useState("");
  const [isLoginButton, setIsLoginButton] = useState(false);
  const [isLoginButtonDisable, setIsLoginButtonDisable] = useState(true);
  const [isVerifyButton, setIsVerifyButton] = useState(false);
  const [isVerifyButtonDisable, setIsVerifyButtonDisable] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    isError: false,
    message: "",
  });
  const navigate = useNavigate();
  const token = getLocalStorage("token") ? getLocalStorage("token") : "";
  useEffect(() => {
    if(token){
      navigate("/home");
    }
  }, [navigate,token]);

  const initState = {
    phoneCode: "+91",
    phone: "",
  };
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: initState,
    mode: "onBlur",
  });

  const formOptions: any = {
    phoneCode: { required: "Country code is required" },
    phone: {
      onChange: (e: any) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
          let phoneLength = e.target.value.slice(0, 10);
          setValue("phone", phoneLength);
          phoneLength.length >= 10 ? setIsLoginButtonDisable(false) : setIsLoginButtonDisable(true)
        } else {
          setValue("phone", "");
          setIsLoginButtonDisable(true)
        }
      },
      required: "Enter mobile number",

      minLength: {
        value: 10,
        message: "Enter 10 digits",
      },
      maxLength: {
        value: 10,
        message: "Enter 10 digits",
      },
      pattern: {
        value: /^[0-9+-]+$/,
        message: "Enter valid mobile number",
      },
    },
  };

  const onSubmit = () => {
    setOtp("");
    setIsVerifyButton(false);
    // console.log("Values:::", values);
    // console.log("Values:::", JSON.stringify(values));
    setIsLoginButton(true);
    const apiObject: PayloadProps = {
      payload: {
        mobile: getValues("phone"),
      },
      method: "POST",
      apiUrl: apiEndpoint.signInApi,
      // headers: {Authorization: guestToken}
    };

    triggerApi(apiObject).then((res: any) => {
      // console.log(res);
      if (res && res.statusCode && res.statusCode === "success") {
        setShowVerify(true);
        setLocalStorage('users_type_id', res.users_type_id)
      } else if (res && res.statusCode && res.statusCode === "error") {
        setIsLoginButtonDisable(true);
        setErrorMsg({
          isError: true,
          message: res.statusMsg ?? "Something wrong.",
        });

        setTimeout(() => {
          setErrorMsg({
            isError: false,
            message: "",
          });
        }, 4000);
      }
      setIsLoginButton(false);
    });
  };

  const onOtpVerify = () => {
    // console.log(otp.toString().length);
    setIsVerifyButton(true);
    if (otp.length < 6) return;
    const apiObject: PayloadProps = {
      payload: {
        mobile: getValues("phone"),
        verify_code: otp,
      },
      method: "POST",
      apiUrl: apiEndpoint.signInApi,
      // headers: {Authorization: guestToken}
    };

    triggerApi(apiObject).then((res: any) => {
      console.log(res);
      if (res.statusCode && res.statusCode === "success") {
        setShowVerify(false);
        setOtp("");
        setLocalStorage("token", res.data.auth_token);
        setLocalStorage("user", JSON.stringify(res.data.user_details));
        navigate("/home");
        // window.location.href = `${process.env.REACT_APP_HOMEPAGE+"/"}`;
      } else if (res.statusCode && res.statusCode === "error") {
      }
    });
  };

  const onError = (error: any) => {
    console.log("ERROR:::", error);
  };

  // https://codesandbox.io/s/y74yf?file=/src/App.js
  const onOtpChange = (otpText: string) => {
    // console.log(otpText, otpText.toString().length);
    setOtp(otpText);
    otpText.toString().length >= 6
      ? setIsVerifyButtonDisable(false)
      : setIsVerifyButtonDisable(true);
  };

  const resendOtp = () => {
    setOtp("")
    onSubmit();
  }

  return (
    <>
      <Modal
        // {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showVerify}
        onHide={() => setShowVerify(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Verify OTP
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex">
            <OtpInput value={otp} valueLength={6} onChange={onOtpChange} />
            <div className="center-content">
            <Button variant="link" onClick={resendOtp}>Resend OTP</Button>
            </div>
            <Button
              onClick={onOtpVerify}
              disabled={isVerifyButtonDisable}
              className="mt-10"
            >
              {isVerifyButton ? (
                <>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </>
              ) : (
                "Verify"
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Container>
        <Row className="logo">
          <Col xs={12}>
            <div className="d-flex justify-content-center">
              <img src={logo} width="100px" height="100px" alt="" />
            </div>
          </Col>
        </Row>
        <Form
          // noValidate
          // validated={validated}
          onSubmit={handleSubmit(onSubmit, onError)}
          onChange={() => {}}
        >
          {errorMsg.isError && (
            <Alert
              key="danger"
              variant="danger"
              dismissible
              onClose={() => setErrorMsg({ isError: false, message: "" })}
            >
              {errorMsg.message}
            </Alert>
          )}
          <Row className="mt-4">
            <Col xs={2}>
              <Form.Control
                type="text"
                // placeholder="+91"
                disabled={true}
                {...register("phoneCode", formOptions.phoneCode)}
              />
              {errors?.phoneCode && (
                <div className="text-danger">{errors.phoneCode.message}</div>
              )}
            </Col>
            <Col xs={10} className="ml-2">
              <Form.Control
                type="text"
                {...register("phone", formOptions.phone)}
              />
              {/* {errors?.phone && (
                <div className="text-danger">{errors.phone.message}</div>
              )} */}
            </Col>
          </Row>

          <Row className="mt-4">
            <Col xs={12} className="d-grid gap-2">
              <Button variant="primary" type="submit" disabled={isLoginButtonDisable}>
                {isLoginButton ? (
                  <>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : (
                  "Send"
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  );
}
